import BaseEndpoint from '@/api/endpoints/base-endpoint'
export default class EventEndpoint extends BaseEndpoint {}
